export const MySuccessOpen = {
	Action: 'coachProgAction',
	Language: 'coachLanguage',
	LevelStatus: 'coachLevelStatus',
	LevelPoints: 'coachLevelPoints',
};
